import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const Container = () => {
  const { navigation } = useNavigation()

  return <Navigate to={navigation.talentAnalytics.headcount.path} replace />
}

const RedirectToDefaultPage = () => {
  return <Container />
}

export default RedirectToDefaultPage
